import { DefaultDialogDom, IDialogController, IDialogCustomElementViewModel, IDialogDom } from "@aurelia/dialog";
import { IRouter } from "@aurelia/router";
import { ICustomElementController } from "@aurelia/runtime-html";
import { inject } from "aurelia";

@inject(IDialogDom, IRouter)
export class CreateBrandComponent implements IDialogCustomElementViewModel {

  $controller?: ICustomElementController<this>;
  $dialog: IDialogController;

  private message: string

  constructor(
    private dialogDom: DefaultDialogDom,
    private router: IRouter,
  ) {
    this.dialogDom.overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    this.dialogDom.overlay.classList.add('backdrop-blur-glassed-button')
  }

  activate(model: {
    message: string,
  }) {
    this.message = model.message;
  }

  navigateToBrandGuide() {
    this.router.load('brand-guide')
    this.$dialog.ok()
  }

}